module.exports = __webpack_public_path__ + "static/img/12.83befd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/9/12.png
// module id = cM1Y
// module chunks = 2